import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { MenuItem } from 'primereact/menuitem';
import React, { useRef, useState } from 'react';

import CoachingToDo from '../CoachingToDo/CoachingToDo';
import CoachingShoutOut from '../coachingShoutOut/coachingShoutOUt';

const CoachingSpawnLauncher = (props: any) => {
    const menuLeft = useRef<Menu>(null);
    const [showShoutOutDialog, setShowShoutOutDialog] = useState<boolean>(false);
    const [showToDoDialog, setShowToDoDialog] = useState<boolean>(false);

    const items: MenuItem[] = [
        {
            label: 'To Do',
            command: () => {
                setShowToDoDialog(true);
            },
        },
        {
            label: 'Shout Out',
            command: () => {
                setShowShoutOutDialog(true);
            },
        },
        // {
        //     label: 'Team Event',
        //     command: () => {},
        //     disabled: true,
        // },
    ];

    return (
        <>
            <>
                <Menu model={items} popup ref={menuLeft} id="popup_menu_left" />
                <Button
                    label="Add New"
                    icon="pi pi-plus-circle"
                    className="btn-primary mr-2 me-2"
                    onClick={(event) => menuLeft.current?.toggle(event)}
                    aria-controls="popup_menu_left"
                    aria-haspopup
                />
            </>

            {showShoutOutDialog && (
                <CoachingShoutOut
                    visible={showShoutOutDialog}
                    setVisible={setShowShoutOutDialog}
                    coachingEntityTypeId={1}
                    coachingEntityId={0}
                    coreValueId={0}
                />
            )}
            {showToDoDialog && (
                <CoachingToDo
                    visible={showToDoDialog}
                    setVisible={setShowToDoDialog}
                    coachingEntityTypeId={1}
                    coachingStatusId={props.statusId}
                    coachingEntityId={0}
                />
            )}
        </>
    );
};
export default CoachingSpawnLauncher;
